/**
 * 자녀 아바타 공통 컴포넌트
 *  - photoURL 있으면 이미지로 표시
 *  - 없으면 회색 동그라미 + IoPeople 사람 아이콘 + 1등급 라벨
 *  - 사이즈에 따라 라벨 글자 크기 자동 조정 (작은 사이즈에선 라벨 생략)
 */
import React from 'react';
import styled from 'styled-components';
import { IoPeople } from 'react-icons/io5';

const ChildAvatar = ({ photoURL, name = '', size = 40 }) => {
  if (photoURL) {
    return <Img src={photoURL} alt={name} $size={size} />;
  }
  const iconSize = Math.round(size * 0.5);
  const showLabel = size >= 48;
  const labelHeight = Math.max(15, Math.round(size * 0.26));
  const labelFontSize = Math.max(10, Math.round(size * 0.17));
  const labelPadX = Math.round(labelHeight * 0.5);

  return (
    <Wrap $size={size}>
      <IoPeople size={iconSize} color="#9CA3AF" />
      {showLabel && (
        <Badge $h={labelHeight} $fs={labelFontSize} $px={labelPadX}>
          1등급
        </Badge>
      )}
    </Wrap>
  );
};

export default ChildAvatar;

const Img = styled.img`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  object-fit: cover;
  background: #F3F4F6;
  flex-shrink: 0;
`;

const Wrap = styled.div`
  position: relative;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  background: #F3F4F6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
`;

const Badge = styled.span`
  position: absolute;
  bottom: 6%;
  left: 50%;
  transform: translateX(-50%);
  height: ${({ $h }) => $h}px;
  padding: 0 ${({ $px }) => $px}px;
  border-radius: ${({ $h }) => $h / 2}px;
  background: #4A7CFE;
  color: #fff;
  font-size: ${({ $fs }) => $fs}px;
  font-weight: 800;
  line-height: ${({ $h }) => $h}px;
  letter-spacing: -0.3px;
  white-space: nowrap;
`;
